'use client';

import { atom } from 'jotai';

import { atomFamily } from 'jotai/utils';

import { LeadFormId } from '@core/Entities/Leads/LeadFormId';

import { LeadFormData } from './FormConfig.entity';

const defaultLeadFormData: LeadFormData = {
  title: undefined,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  phone: undefined,
  postcode: undefined,
  message: undefined,
  autoCallbackPreference: {
    callBackInstantlyChkBox: undefined,
    callBackDuringDayChkBox: undefined,
  },
  phoneWithCountryCode: {
    countryCode: undefined,
    phone: undefined,
  },
  bookAppointment: { bookAppointmentTime: undefined, bookAppointmentDate: undefined },
  partExchange: {
    partExchangeRegistration: undefined,
    partExchangeMileage: undefined,
    partExchangeSendValuation: undefined,
  },
  financeQuote: { financeQuoteChecked: undefined, financeQuoteTcsChecked: undefined },
  multiLeadCheckboxes: {
    driftrockChkBox: undefined,
    oneClickChkBox: undefined,
    oneClickDriftrockChkBox: undefined,
  },
  reservationCheckbox: undefined,
  marketingOptIn: undefined,
};

export const leadFormDataAtom = atomFamily((_formId: LeadFormId) =>
  atom<LeadFormData>(defaultLeadFormData),
);
